import { TgConversation, TgMsg, TgPagination, TgMember, TgChannel, TgChat, TgUser, SearchChatByUser, TgChatToSearch } from "@/store/modules/telegram/types";
import axios from '@/requests';

export interface TgBaseParam extends TgPagination {
    projid: string,
    uid: string,
    tgid: number,
}

export interface GetTgParamWithConvId extends TgBaseParam {
    convid: number,
}

export interface GetTgIdParam {
    projid: string,
    uid: string,
}

export interface FuzzySearchParams extends TgBaseParam {
    target: string,
}

export interface FuzyySearchMsgByConvId extends FuzzySearchParams {
    convId: number
}

export interface GetMsgByConvIdAndUserId extends GetTgParamWithConvId {
    userid: number,
}


export const tgAPI = {
    async asyncGetConvListByUidAndTgId(reqParam: TgBaseParam): Promise<TgConversation[]> {
        try {
            return await axios.get<TgConversation[]>("/Tg/getConvListByUidAndTgId", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetChannelListByUidAndTgId(reqParam: TgBaseParam): Promise<TgChannel[]> {
        try {
            return await axios.get<TgChannel[]>("/Tg/getTgChannelListByUidAndTgId", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetChatListByUidAndTgId(reqParam: TgBaseParam): Promise<TgChat[]> {
        try {
            return await axios.get<TgChat[]>("/Tg/getTgChatListByUidAndTgId", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetUserListByUidAndTgId(reqParam: TgBaseParam): Promise<TgUser[]> {
        try {
            return await axios.get<TgUser[]>("/Tg/getTgUserListByUidAndTgId", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    // async asyncGetChannelMsgListByTgIdAndConvId(reqParam: GetTgParamWithConvId): Promise<TgMsg[]> {
    //     try {
    //         return await axios.get<TgMsg[]>("/Tg/getChannelMsgByUidAndTgidAndConvid", reqParam);
    //     } catch (err) {
    //         return Promise.reject(err);
    //     }
    // },
    // async asyncGetGroupMsgListByTgIdAndConvId(reqParam: GetTgParamWithConvId): Promise<TgMsg[]> {
    //     try {
    //         return await axios.get<TgMsg[]>("/Tg/getGroupMsgByUidAndTgidAndConvid", reqParam);
    //     } catch (err) {
    //         return Promise.reject(err);
    //     }
    // },
    // async asyncGetUserMsgListByTgIdAndConvId(reqParam: GetTgParamWithConvId): Promise<TgMsg[]> {
    //     try {
    //         return await axios.get<TgMsg[]>("/Tg/getUserMsgByUidAndTgidAndConvid", reqParam);
    //     } catch (err) {
    //         return Promise.reject(err);
    //     }
    // },
    async asyncGetTgMsgsByTgConvId(reqParam: GetTgParamWithConvId): Promise<TgMsg[]> {
        try {
            return await axios.get<TgMsg[]>("/Tg/getTgMsgListByTgConvId", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetParticipantsByUidAndTgIdAndConvId(reqParam: GetTgParamWithConvId): Promise<TgUser[]> {
        try {
            return await axios.get<TgUser[]>("/Tg/getParticipantListByUidAndTgIdAndConvId", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetTgIdByProjIdAndUid(reqParam: GetTgIdParam): Promise<TgUser[]> {
        try {
            return await axios.get<TgUser[]>("/Tg/getTgIdByProjIdAndUid", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncFuzzySearchContactForTg(reqParam: FuzzySearchParams): Promise<TgUser[]> {
        try {
            return await axios.get<TgUser[]>("/Tg/fuzzySearchContactForTg", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncFuzzySearchChatForTg(reqParam: FuzzySearchParams): Promise<TgConversation[]> {
        try {
            return await axios.get<TgConversation[]>("/Tg/fuzzySearchChatForTg", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncgetMsgListForSearchResultOfChat(reqParam: FuzyySearchMsgByConvId): Promise<TgMsg[]> {
        try {
            return await axios.get<TgMsg[]>("/Tg/getMsgListForSearchResultOfChat", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },

    async asyncGetChatListByUser(reqParam: FuzzySearchParams): Promise<TgChatToSearch[]> {
        try {
            return await axios.get<TgChatToSearch[]>("/Tg/getChatListByUser", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },

    async asyncGetMsgListByConvIdAndUserId(reqParam: GetMsgByConvIdAndUserId): Promise<TgMsg[]> {
        try {
            return await axios.get<TgMsg[]>("/Tg/getMsgListByConvIdAndUserId", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },



}